<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="m56 24-24 8-24-8m48 11.33V50l-24 8-24-8V35.33M56 24l-24-8-24 8m24 8 4 10 24-8-4-10 4-10-24-8-4 10-4-10-24 8 4 10-4 10 24 8zm0 26V32m0-16v10" style="stroke:#424242;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10"/></svg>
</template>
